import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { LoginCheckerModal, LoginCheckerModalFromSubApp } from "../components/Modal";
import { useLocation } from "react-router";


export default function Home() 
{

  const pages = [
    { title: "Commencer", desc: "Découvrez et explorez les différentes applications et fonctionnalités qu’Agrospace met à votre disposition.", icon: "bi-lightning-charge-fill" },
    { title: "Intelligence Artificielle", desc: "Agrospace intègre des solutions d’IA avancées pour automatiser certaines tâches agricoles et faciliter l'accès à l'information.", icon: "bi-cpu" },
    { title: "Données", desc: "La gestion et l’analyse des données sont au cœur d’Agrospace. Avec le monitoring d’exploitation en temps réel de produit agricole", icon: "bi-database" },
    { title: "Ergonomie", desc: "Agrospace offre une interface intuitive, permettant aux utilisateurs de naviguer entre les différentes applications sans difficulté.", icon: "bi-laptop" },
    { title: "Réseautage", desc: "Le réseau social intégré à Agrospace permet aux acteurs de partager des expériences, de vendre des produits agricole et bien d'autres", icon: "bi-diagram-3" },
    { title: "Packages", desc: "Agrospace propose un ensemble d’outils modulables que ce soit le monitoring, le chatbot ou le réseau social,", icon: "bi-box-seam" },
  ];

  const info = [
    { title: "Recherche scientifique", desc: "Agrospace met en lumière les résultats et innovations issus de la recherche scientifique appliquée à l’agriculture. La plateforme facilite l’accès aux études, recommandations et bonnes pratiques, permettant aux agriculteurs et professionnels de tirer parti des dernières avancées pour améliorer leurs méthodes de production.", icon: "bi bi-check-circle-fill" },
    { title: "Accès simplifié à l’information", desc: "Grâce à ses applications intégrées, Agrospace centralise des données fiables et actualisées sur la météo, les cultures, les marchés et les techniques agricoles et tant d'autres. Les utilisateurs peuvent ainsi obtenir rapidement l’information dont ils ont besoin pour prendre des décisions éclairées et optimiser la gestion de leurs exploitations.", icon: "bi bi-check-circle-fill" },
    { title: "Collaboration et mise en réseau", desc: "Agrospace favorise les échanges entre acteurs du secteur agricole grâce à son réseau social intégré. Agriculteurs, chercheurs et experts peuvent partager leurs expériences, poser des questions, collaborer sur des projets et créer des communautés d’entraide pour renforcer la coopération et l’innovation dans le domaine.", icon: "bi bi-check-circle-fill" },
  ];

  const [ loginChecker , setloginChecker ] = useState(false);
  const closeoginCheckerModal = ( arg ) => {  setloginChecker( arg ) }

  const getAccessApp = (url) => {
      setloginChecker(false);
      (localStorage.getItem('token')) ? window.open(url, "_blank", "noopener,noreferrer") : setloginChecker(true);      
  }


  const gradients = [
    "linear-gradient(180deg, rgba(16,185,129,0.03) 0%, rgba(16,185,129,0.06) 45%, rgba(16,185,129,0.06) 55%, rgba(16,185,129,0) 100%)",
    "linear-gradient(180deg, rgba(59,130,246,0.03) 0%, rgba(59,130,246,0.06) 45%, rgba(59,130,246,0.06) 55%, rgba(59,130,246,0) 100%)",
    "linear-gradient(180deg, rgba(234,179,8,0.03) 0%, rgba(234,179,8,0.06) 45%, rgba(234,179,8,0.06) 55%, rgba(234,179,8,0) 100%)"
  ];

  const [bg, setBg] = useState(gradients[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      setBg(prev => {
        const currentIndex = gradients.indexOf(prev);
        const nextIndex = (currentIndex + 1) % gradients.length;
        return gradients[nextIndex];
      });
    }, 5000);

    return () => clearInterval(interval); 
  }, []);


  // Handle URL parameters for access control
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("ad") === "true") {
      setShowModal(true);
    }
  }, [location.search]);


  return (
    <div className="bg-light min-vh-100">
      {
        showModal && (
          <LoginCheckerModalFromSubApp method={ () => setShowModal(false) } message={"L’accès aux applications énumérées ci-dessous demeure restreint tant que votre authentification sur AgroSpace n’a pas été effectuée"} />
        )
      }
      { loginChecker && ( 
        <LoginCheckerModal method={ closeoginCheckerModal } message={"Erreur d'acces, Vueillez vous connecter dabord avant toute tentative d'accès aux applications."} /> 
         )  
      }
      {/* Header's section */}
      <Header page={1} />
      <div className="bg-light min-vh-100">

      {/* Agrospace description section */}
      <section className="hero-wrap py-5 text-center" style={{
        background: bg,
        transition: "background 2s ease"
      }}>
        <div className="container py-4">
          <h2 className="fw-bold"> Agrospace solution </h2>
          <p className="lead text-muted mx-auto">
            Agrospace est une plateforme vitrine innovante qui centralise plusieurs applications spécialisées dans différents domaines du secteur agricole. Elle a été conçue pour faciliter l’accès à l’information, améliorer la prise de décision et optimiser la gestion des activités agricoles. Grâce à Agrospace, les acteurs du secteur peuvent consulter des données pertinentes, suivre l’évolution de leurs exploitations, gérer leurs ressources et bénéficier d’outils Intelligents adaptés à leurs besoins spécifiques, le tout depuis un espace unique et intuitif.
          </p>
          <div className="d-flex justify-content-center mt-5">
            <a className="btn btn-lg btn-outline-dark d-flex align-items-center" href="#apps">
              Mes applications <i className="bi bi-arrow-right ms-2"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Service's section */}
      <div className="container pb-5 mb-5">
        <div className="row g-4">
          { pages.map((item, idx) => (
            <div className="col-lg-4 col-md-6" key={idx}>
              <div className="card h-100 shadow-sm border-0 rounded-3 text-center p-4">
                <div className="fs-1 text-success mb-2">
                  <i className={`bi ${item.icon}`}></i>
                </div>
                <h5 className="fw-bold">{item.title}</h5>
                <p className="text-muted">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Dark bar */}
      <div className="bg-dark text-light d-flex justify-content-center align-items-center p-3" id="apps">
        <div className="d-flex align-items-center">
          <span className="h5 d-flex align-items-center px-4 py-1 border-end border-2 mt-2">Nos applications </span>
          <span className="px-4 py-1 d-flex align-items-center gap-3">
            Agrospace est un ensemble d’applications innovantes dédié au secteur agricole
            <a href="/tarifs" className="link text-decoration-underline text-light"> <i className="bi bi-arrow-right"></i></a>
          </span>
        </div>
      </div>

      {/* APPs section */}
      <div className='container py-5'>
        <div className='row justify-content-center py-5'>

            <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
              <div className='d-flex flex-column align-items-center gap-2'>
                <div className="d-flex justify-content-center border rounded-2 p-3">
                  <img src="../img/jaari-app-icon.png" alt="icon-agrospace" width="60" className=""/>
                </div>
                <p className='text-muted'> Jaari chatbot </p>
                <button disabled className='btn btn-outline-dark mb-2 w-75 rounded-pill' onClick={ ()=> getAccessApp( process.env.REACT_APP_JAARI_URL ) }>
                  Exploiter <i className='bi bi-arrow-right'></i>
                </button>
                <p className='text-muted text-center'> Votre assistant intelligent pour le secteur agricole. </p>
              </div>
            </div>
            <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
              <div className='d-flex flex-column align-items-center gap-2'>
                <div className="d-flex justify-content-center align-items border rounded-2 p-3">
                  <img src="../img/agriteam-app-icon.png" alt="icon-agrospace" width="60" className=""/>
                </div>
                <p className='text-muted'> Agriteam </p>
                <button className='btn btn-outline-dark mb-2 w-75 rounded-pill' onClick={ ()=> getAccessApp( process.env.REACT_APP_AGRITEAM_URL ) } >
                  Exploiter <i className='bi bi-arrow-right'></i>
                </button>
                <p className='text-muted text-center'> Le réseau social dédié aux acteurs du secteur agricole. </p>
              </div>
            </div>
            <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
              <div className='d-flex flex-column align-items-center gap-2'>
                <div className="d-flex justify-content-center border rounded-2 p-3">
                  <img src="../favicon.png" alt="icon-agrospace" width="60" className=""/> 
                </div>
                <p className='text-muted'> FarmSpace </p>
                <button disabled className='btn btn-outline-dark mb-2 w-75 rounded-pill' onClick={ ()=> getAccessApp(process.env.REACT_APP_MONITORING_URL) } >
                  Exploiter <i className='bi bi-arrow-right'></i>
                </button>
                <p className='text-muted text-center'> L’outil de monitoring d’exploitation et de gestion agricole. </p>
              </div>
            </div>

        </div>
      </div>

      {/* Video's section */}
      <div className="container-fluid bg-green-light text-light d-flex justify-content-center align-items-center py-5" id="video">
        <div className="row align-items-center py-5 px-4">
          {/* Text content on the left */}
          <div className="col-lg-5 mb-4 mb-lg-0 py-4 border">
            <p className="text-dark h1 fw-bold mb-3"> Plateforme Agrospace </p>
            <p className="lead text-muted mx-auto">
             Agrospace est une plateforme qui regroupe plusieurs applications dédiées au secteur agricole, permettant aux utilisateurs d’accéder facilement à l’information, de gérer leurs exploitations et de collaborer avec d’autres acteurs du domaine.
            </p>
            <div className="d-flex mt-3">
              <a className="btn btn-lg btn-outline-dark d-flex align-items-center" href="/produits">
                Nos produits <i className="bi bi-arrow-right ms-2"></i>
              </a>
            </div>
          </div>
          <div className="col-lg-1"></div>
          {/* Video placeholder on the right */}
          <div className="col-lg-6 p-3 border">
            <div className="embed-responsive embed-responsive-16by9 bg-light rounded shadow-sm d-flex justify-content-center align-items-center" style={{ height: '350px' }}>
              <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/m1xg_6SkJkk?si=R21MokrVLijcW0q7" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center py-5 mt-5">
        <h1> Référence dans le secteur agricole </h1>
      </div>

      {/* Popular Pages */}
      <div className="container pb-5 pt-4">
        <div className="row g-4 pb-5">
          {info.map((item, idx) => (
            <div className="col-lg-4 col-md-6 px-4" key={idx}>
              <div className="d-flex align-items-center mb-3">
                <div className="fs-4 text-success me-2 mb-2">
                  <i className={item.icon}></i>
                </div>
                <h4>{item.title}</h4>
              </div>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

    </div>

    {/* Footer's section */}
    <Footer />
      
  </div>
  );
}
